<template>
    <div id="app" :class="appClasses">
        <!-- New template -->
        <template v-if="newTemplate">
            <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
                <new-alerts/>
                <sidebar v-show="!globalLoadingState"/>
                <loader v-show="globalLoadingState" class="color"/>
                <div v-if="!globalLoadingState" class="main-panel">
                    <toolbar/>
                    <div class="content">
                        <router-view v-show="!loadingState"/>
                        <loader v-show="loadingState" class="color"/>
                    </div>
                </div>
            </div>
        </template>

        <!-- Old template -->
        <template v-else>
            <alerts/>
            <loader v-show="globalLoadingState" class="color global"/>
            <router-view v-show="!globalLoadingState"/>
        </template>
    </div>
</template>

<script>
import Alerts from "./old/layouts/Alerts";
import NewAlerts from "./new/layouts/Alerts";
import Sidebar from "./new/components/SidebarPlugin/SideBar";
import {mapGetters} from "vuex";
import Loader from "./old/components/Loader";
import Toolbar from "./new/layouts/Toolbar";
import AuthService from "./new/services/AuthService";

export default {
    name: 'App',
    components: {Toolbar, Loader, Sidebar, Alerts, NewAlerts},
    computed: {
        newTemplate() {
            let oldPages = [
                this.$enums.RoutePathEnum.LOGIN,
                this.$enums.RoutePathEnum.FEDERATED_TOKEN_LOGIN,
                this.$enums.RoutePathEnum.FEDERATED_EMAIL_LOGIN,
                this.$enums.RoutePathEnum.CUSTOM_LOGIN,
                this.$enums.RoutePathEnum.CUSTOM_FORGOT_PASSWORD,
                this.$enums.RoutePathEnum.LOGIN_DASHBOARD,
                this.$enums.RoutePathEnum.LOGIN_DASHBOARD_POPUP,
                this.$enums.RoutePathEnum.FORGOT_PASSWORD,
                this.$enums.RoutePathEnum.ACCOUNT_CONFLICT,
                this.$enums.RoutePathEnum.FORGOT_PASSWORD_FINISH,
                this.$enums.RoutePathEnum.ACCOUNT_UNIFICATION,
                this.$enums.RoutePathEnum.CHANGE_PASSWORD,
                this.$enums.RoutePathEnum.MAINTENANCE_MODE_DASHBOARD
            ]

            if (this.$route.matched[0] !== undefined) {
                return !oldPages.includes(this.$route.matched[0].path);
            }

            return false;
        },
        appClasses() {
            return {
                'new-template': this.newTemplate,
                'old-template': !this.newTemplate,
            }
        },
        ...mapGetters('app', {
            globalLoadingState: 'getGlobalLoadingState',
            loadingState: 'getLoadingState',
        })
    },
    methods: {
        logout() {
            AuthService.logout();
        },
        globalInit() {
            this.$api.globalInit();
        }
    },
    mounted() {

        this.globalInit();
        let action = this.$route.query.action ?? '';

        if (action === 'logout') {
            this.logout();
        }

        if (this.$route.path === '/') {
            this.$router.push(this.$enums.RoutePathEnum.LOGIN);
        }

        //TODO: delete after 06.08.2021
        //Delete old access token assign to site, now we use access token assign to domain
        this.$cookies.remove('accessToken');

    },
    created() {
        this.$bus.on('logout', this.logout);
    },
    beforeDestroy() {
        this.$bus.off('add-todo', this.logout);
    },
}
</script>

<style lang="scss">
html, body, #app {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    font-family: 'Roboto', sans-serif !important;
    letter-spacing: normal !important;
    line-height: normal !important;
    font-size: 16px !important;
    font-weight: 500 !important;
}

@import "old/scss/main";
@import "new/scss/main";

// This is bad code but because of using frontend framework we need to override  links (at this moment for login page) to use css variable not scss
* > div > a {
    &:hover, &:focus {
        color: var(--accent-color) !important;
    }
}


</style>
